import { showResponseMessage } from "../Components/utils/handellApiResponse";
import PropertiesServices from "../api-services/properties-services";

export const createPropertiesSlice = (set) => ({
  styleLoading: false,
  socialMedia: [],
  socialMediaElemnt: {},
  socialMediaLoading: false,

  

  fetchSocialMediaFunction: async (id) => {
    set((state) => ({
      ...state,
      socialMediaLoading: true,
    }));
    try {
      const res = await PropertiesServices.getSocailMedia(id);
      set((state) => ({
        ...state,
        socialMedia: res.data.data,
        socialMediaLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        socialMediaLoading: false,
      }));
    }
  },

  updateSocialMediaFunction: async (item) => {
    set((state) => ({
      ...state,
      socialMediaLoading: true,
    }));
    try {
      const res = await showResponseMessage(
        PropertiesServices.updateSocailMedia(item),
        "update"
      );
      set((state) => ({
        ...state,
        socialMedia: state.socialMedia.map((e) => {
          if (e.id === item.id) e = res.data.data;
          return e;
        }),
        socialMediaLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        socialMediaLoading: false,
      }));
    }
  },
  storeSocialMediaFunction: async (item) => {
    set((state) => ({
      ...state,
      socialMediaLoading: true,
    }));
    try {
      const res = await showResponseMessage(
        PropertiesServices.storeSocailMedia(item),
        "store"
      );
      set((state) => ({
        ...state,
        socialMedia: [...state.socialMedia, res.data.data],
        socialMediaLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        socialMediaLoading: false,
      }));
    }
  },

  deleteSocialMediaFunction: async (id) => {
    set((state) => ({
      ...state,
      socialMediaLoading: true,
    }));
    const res = await showResponseMessage(
      PropertiesServices.deleteSocailMedia(id),
      "delete"
    );
    try {
      set((state) => ({
        ...state,
        socialMedia: state.socialMedia.filter((e) => e.id !== id),
        socialMediaLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        socialMediaLoading: false,
      }));
    }
  },
  setSocialMediaElement: (element) => {
    set((state) => ({
      ...state,
      socialMediaElemnt: element,
    }));
  },
});
